import { render, staticRenderFns } from "./SupplierTagsEdit.vue?vue&type=template&id=4cb67c48&scoped=true&"
import script from "./SupplierTagsEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierTagsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb67c48",
  null
  
)

export default component.exports